import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-gain',
  templateUrl: './help-gain.component.html',
  styleUrls: ['./help-gain.component.scss']
})
export class HelpGainComponent implements ContentModel {
  static ref = HelpModel.GAIN;
  static title = 'Gain Settings';

  showBackHeader = true;

  helpTitle = HelpGainComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
